import React from 'react';



export default function HomePage() {
    return (
        <section className="w-full py-12 md:py-24 lg:py-32 xl:py-48 bg-gray-900 h-screen flex justify-center">
            <div className="container px-4 md:px-6 flex justify-center">
                <div className="flex flex-col justify-center space-y-4">
                    <div className="space-y-2">
                        <h1 className="text-3xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-500">
                           Welcome to Free Reward Apps
                        </h1>
                        <p className="max-w-[600px] text-zinc-500 md:text-xl dark:text-zinc-400">
                            Manage all your reward links at one place like
                        </p>
                    </div>
                    <div className="w-full max-w-sm space-y-2">

                        <p className="text-xs text-white">
                            Coin Master,dice dream,monopoly go and more <span></span>
                            <a className="underline underline-offset-2" href="/privacy-policy">
                                  Privacy
                            </a>
                        </p>
                    </div>
                </div>

            </div>
        </section>
    )
}

